import styled from '@emotion/styled'

// Step heading. A plain sentence (no bold fragment), matching the muted,
// centered treatment of the other advice-step headings.
export const Heading = styled.h1`
  width: 90%;
  font-weight: normal;
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 30px;
  line-height: 1.3;
  text-align: center;
  max-width: 760px;
  margin: 0;
  color: ${p => p.theme.mediumGray};

  @media (max-width: 600px) {
    font-size: 24px;
  }
`

export const InvestmentsWrap = styled.div`
  width: 100%;
  max-width: 820px;
  margin-top: 48px;

  @media (max-width: 600px) {
    margin-top: 24px;
  }
`

// Account tabs sit between the heading and the allocation.
export const TabsWrap = styled.div`
  width: 100%;
  max-width: 820px;
  margin-top: 40px;

  @media (max-width: 600px) {
    margin-top: 24px;
  }
`

// Desktop-only header above an individual account's allocation: the account name
// (truncated to one line) on the left, the summary/details toggle on the right.
export const AccountHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 16px;
  margin-bottom: 16px;
`

export const AccountName = styled.div`
  min-width: 0;
  flex: 1 1 auto;
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: ${p => p.theme.darkestGray};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

// Summary / Details segmented control.
export const Toggle = styled.div`
  display: inline-flex;
  flex: 0 0 auto;
  border: 1px solid ${p => p.theme.primaryColor};
  border-radius: 4px;
  overflow: hidden;
`

export const ToggleButton = styled.button`
  appearance: none;
  border: none;
  cursor: pointer;
  padding: 6px 16px;
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 14px;
  background-color: ${p => (p.active ? p.theme.primaryColor : 'transparent')};
  color: ${p => (p.active ? '#ffffff' : p.theme.primaryColor)};

  & + & {
    border-left: 1px solid ${p => p.theme.primaryColor};
  }
`
